import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WidgetsService {

  constructor(private readonly http: HttpClient) {}

  addWidget(body: any) {
    return this.http
      .post<any>(environment.baseURL + '/widget', body)
      .pipe(map((v) => v.data));
  }
}
